import { getStore } from '../../../../../../../../store/client';
import { getScoring, scoringToFormData } from '../../../../../../../../helpers/form.new/tasks/get.scoring';
import { extendFormData } from '../../../../../../../../store/reducers/formStore';
import { getAddress } from '../../../../../../../../helpers/form.new/tasks/get.address';
import analytics from '../../../../../../../../helpers/analytics';

export const onComplete = async () => {
    const { dispatch } = getStore();
    const { formData } = getStore().getState().formStore;

    await Promise.all([
        getScoring(formData, 'creditcards_landing_passport_step').then((scoreData) => {
            const { okbYandexScore, sravniScore } = scoreData;
            analytics.emit({
                event: analytics.events.mainEvent,
                eventCategory: analytics.categories.CreditCard,
                eventAction: 'Показ скорбалла',
                eventLabel: `Сравни - ${sravniScore ? Math.floor(sravniScore as number) : 'Не найден'}|ОКБ - ${
                    okbYandexScore ? Math.floor(okbYandexScore as number) : 'Не найден'
                }`,
            });
            dispatch(extendFormData(scoringToFormData(scoreData)));
        }),
        getAddress(formData).then((addresses) => {
            dispatch(extendFormData(addresses));
        }),
    ]);
};
